import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/oneteg-new-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-b796b810"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-bg" }, null, -1))
const _hoisted_2 = { class: "resetPassword" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-section height-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "d-flex justify-content-center align-content-center flex-column height-90" }
const _hoisted_5 = { class: "col-10 reset-page" }
const _hoisted_6 = { class: "description d-flex flex-column align-items-center justify-content-center" }

import { onMounted, ref, watch, watchEffect } from "vue";
import { ElButton, ElForm, ElFormItem, ElInput } from "element-plus";
import { router, currentRoute } from "@/core/router";
import { changeLocale } from "@/core/i18n";
import i18n from "@/core/i18n/i18n";
import { loginUsernamePassword, otpAuthenticate } from "@/core/auth/auth";
import { showAlert } from "@/core/popup";
import { TYPE } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'OtpAuthenticate',
  setup(__props) {

const { t } = i18n.global;

const loading = ref(false);

const formOtpCode = ref({
  otpCode: "",
});

const formRules = ref({
  otpCode: [
    {
      required: true,
      message: "Verification code is required",
      trigger: "blur",
    },
  ],
});

const validValue = ref(false);

const elForm = ref<InstanceType<typeof ElForm>>();

onMounted(() => {
  watch(
    () => [formOtpCode.value.otpCode],
    () => {
      elForm.value.validate((valid) => {
        validValue.value = valid;
      });
    }
  );
});

const handleOtpAuthenticate = async () => {
  console.log("handleOtpAuthenticate");

  elForm.value.validate(async (valid) => {
    validValue.value = valid;
    if (valid) {
      loading.value = true;
      const isSuccess = await otpAuthenticate(formOtpCode.value.otpCode);
      if (isSuccess) {
        await router.push("auth/login-using-session");
        showAlert(TYPE.SUCCESS, t("Common.WelcomeToOneTeg"));
        console.log("handleOtpAuthenticate success");
      }
      loading.value = false;
    }
    return false;
  });
};

const selectedLocale = ref(currentRoute.value.params.locale as string);
watchEffect(() => changeLocale(selectedLocale.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(ElForm), {
            ref_key: "elForm",
            ref: elForm,
            model: formOtpCode.value,
            rules: formRules.value,
            class: "margin",
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("Common.EnterYourVerificationCode")), 1),
              _createVNode(_unref(ElFormItem), {
                class: "d-flex flex-column align-items-center justify-content-center",
                prop: "otpCode",
                label: _unref(t)('Common.OtpCode')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: formOtpCode.value.otpCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formOtpCode.value.otpCode) = $event)),
                    class: "min-width",
                    onKeydown: _withKeys(_withModifiers(handleOtpAuthenticate, ["prevent"]), ["enter"])
                  }, null, 8, ["modelValue", "onKeydown"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElFormItem), { class: "d-flex flex-column align-items-center justify-content-center" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElButton), {
                    disabled: !validValue.value,
                    loading: loading.value,
                    class: "btn-primary width-350",
                    "native-type": "button",
                    size: "large",
                    onClick: handleOtpAuthenticate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("Common.OtpValidate")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ], 64))
}
}

})